import {
  EdgeProps,
  BaseEdge,
  getSmoothStepPath,
  EdgeLabelRenderer,
  Edge,
} from "@xyflow/react";
import { useAtomValue } from "jotai";
import {
  EdgeData,
  nodeAtomFamily,
  isDraftNotTemplateNodeAtomFamily,
} from "@zapier/canvas-state";
import { Colors } from "@zapier/design-system";
import styles from "./ZapStepEdge.module.css";

const ZapStepEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerStart,
  markerEnd,
  data,
  target,
}: EdgeProps<Edge<EdgeData>>) => {
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });
  const hasLabel = data && data.label;

  // Target node will always be a zap step node
  const targetNode = useAtomValue(nodeAtomFamily(target));

  const parentZapNodeId = targetNode?.parentId;

  // Check if parent zap node is draft (not template)
  const isParentZapNodeDraftNotTemplate = useAtomValue(
    isDraftNotTemplateNodeAtomFamily(parentZapNodeId),
  );

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={markerEnd}
        markerStart={markerStart}
        style={{
          stroke: isParentZapNodeDraftNotTemplate
            ? Colors.GrayWarm6
            : Colors.BrandOrange,
        }}
      />
      {hasLabel && (
        <EdgeLabelRenderer>
          <div
            style={{
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            }}
            className={`${styles.edgeLabel} nodrag nopan`}
          >
            {data.label}
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
};

export default ZapStepEdge;
